// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"962":"ec3d9a0e","990":"4906806d"}[chunkId] + ".chunk.js";
};